import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface AssignableTeam {
  id: string
  name: string
  campaignId: string | null
}

export interface AssignableAgent {
  agentId: string
  label: string
  teamIds: string[]
}

export interface UseAssignableAgentsResult {
  agents: AssignableAgent[]
  teams: AssignableTeam[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useAssignableAgents(fetchOnMount = false, telephonyOnly = false): UseAssignableAgentsResult {
  const [agents, setAgents] = useState<AssignableAgent[]>([])
  const [teams, setTeams] = useState<AssignableTeam[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const url = telephonyOnly
        ? '/conversations/assignable-agents?telephonyOnly=true'
        : '/conversations/assignable-agents'
      const res = await api.get<{ agents: AssignableAgent[]; teams: AssignableTeam[] }>(url)
      setAgents(res.agents || [])
      setTeams(res.teams || [])
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch agents')
    } finally {
      setLoading(false)
    }
  }, [telephonyOnly])

  useEffect(() => {
    if (fetchOnMount) {
      void refetch()
    }
  }, [fetchOnMount, refetch])

  return { agents, teams, loading, error, refetch }
}
